const title = "満足度との関係性の強さランキング（全体）";
const rank = [
  "1位",
  "2位",
  "3位",
  "4位",
  "5位",
  "6位",
  "7位",
  "8位",
  "9位",
  "10位",
  "11位",
  "12位",
  "13位"
];
const MeasureSize = (data, xCategories) => ({
  chart: {
    type: "bar"
  },
  title: {
    text: title
  },
  colors: ["#3f51b5"],
  xAxis: {
    categories: xCategories,
    crosshair: true,
    labels: {
      align: "right",
      useHTML: true,
      formatter() {
        return ` <span style="display: inline-block;width: 150px;">${
          rank[this.pos]
        } ${this.value}</span> `;
      }
    }
  },
  yAxis: {
    min: 0,
    max: 1.0,
    title: null,
    tickInterval: 0.2
  },
  tooltip: {
    enabled: false
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        format: `{point.y:.3f}`
      }
    },
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    }
  },
  series: [
    {
      name: null,
      data
    }
  ],
  legend: {
    enabled: false
  },
  credits: {
    enabled: false
  }
});

export default MeasureSize;



// WEBPACK FOOTER //
// ./src/models/StrengthOfESAndRelationship.js